<template>
  <div class="resourceDetailWrapper">
    <el-card>
      <div class="top">
        <div class="resDetailInfo">
          <div class="courseInfo">
            <h2>{{ rscDetail.title }}</h2>
            <ul>
              <li v-for="(tag,index) in rscDetail.tags" :key="index">{{ tag }}</li>
            </ul>
            <p class="ewm">
              <img :src="rscDetail.qrImageUrl"/>
              <span>微信扫码看课</span>
            </p>
          </div>
          <div class="studyWrapper">
            <audio-player :rsc-id="rscID" v-if="rscDetail.rscFileType === 4"/>
            <single-video
                ref="childVideo"
                :rsc-id="rscID"
                v-if="rscDetail.rscFileType === 2"
                :if-buy="rscDetail.ifBuy"
            />
            <PDFPlayer
                v-if="rscDetail.rscFileType === 1"
                :rsc-id="rscID"
                :ifBuy="rscDetail.ifBuy"
                :ifFree="rscDetail.ifFree"
            />
            <div
                class="markKnowledge"
                v-if="isLogged && rscDetail.rscFileType === 2 && (rscDetail.ifFree  || rscDetail.ifBuy)"
                @click="switchMark"
            >
              <p>标记知识点</p>
              <i :class="isMark ? 'el-icon-arrow-left' : 'el-icon-arrow-right'"></i>
            </div>
            <div
                class="unBuyTip"
                v-if="!rscDetail.ifBuy && !rscDetail.ifFree && (rscDetail.rscFileType === 4 || rscDetail.rscFileType === 2)"
            >试学3分钟，获取后永久观课
            </div>
          </div>
          <div class="resOther">
            <div class="fav">
              <ul>
                <li class="downNum">
                  <span>{{ rscDetail.downNum }}</span>
                </li>
                <li class="favorite" @click="cancelClick" v-if="rscDetail.favStatus === 1">
                  <span>{{ rscDetail.favNum }}</span>
                </li>
                <li class="cancelCollect" v-if="rscDetail.favStatus === 0" @click="collect">
                  <span>{{ rscDetail.favNum }}</span>
                </li>
                <li class="time">
                  <span>{{ rscDetail.uploadDate }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="teaInfo">
          <div class="author">
            <el-avatar :size="72" :src="author.iconPath" class="avatar">
              <img src="/styles/default_avatar.png"/>
            </el-avatar>
            <p class="userInfo">
              <span class="name">{{ author.realName }}</span>
              <span class="school">{{ author.schoolName }}</span>
              <span class="grade">{{ author.gradeName }}</span>
            </p>
          </div>
          <div v-if="!isMark" class="noMark">
            <div class="courseDesc">
              <h3>资源简介：</h3>
              <div v-if="rscDetail.rscDesc === ''" class="empty">该视频暂无更多介绍</div>
              <p>{{ rscDetail.rscDesc }}</p>
            </div>
            <div class="collectBuyMethods">
              <div class="price">
                价格：
                <span>0.0G分</span>
              </div>
              <div class="collectBuy">
                <a
                    v-if="rscDetail.favStatus === 0"
                    href="javascript:void(0)"
                    class="collect"
                    @click="collect"
                >
                  <span>收藏</span>
                </a>
                <a
                    v-if="rscDetail.favStatus === 1"
                    href="javascript:void(0)"
                    class="collected"
                    @click="cancelClick"
                >
                  <span>已收藏</span>
                </a>
                <a v-if="!rscDetail.ifBuy" href="javascript:void(0)" class="buy" @click="buy">
                  <span>获取</span>
                </a>
                <a
                    v-if="(rscDetail.ifBuy || rscDetail.ifFree) && rscDetail.rscFileType === 1"
                    href="javascript:void(0)"
                    class="download"
                    @click="download"
                >
                  <span>下载</span>
                </a>
              </div>
            </div>
            <div class="collectRecommend">
              <div class="title">
                <h2>专题推荐</h2>
              </div>
              <div v-if="!recommendList.length" class="empty">暂无数据</div>
              <router-link
                  tag="a"
                  target="_blank"
                  :to="'/recommend/list?packID=' + item.packID"
                  v-for="(item,index) in recommendList"
                  :key="index"
                  class="special"
              >
                <span>{{ item.packName }}</span>
              </router-link>
            </div>
          </div>
          <div v-else class="knowledgeWrapper">
            <div class="title">
              <span>课程资料</span>
            </div>
            <a href="javascript:void(0)" class="addKPPoint" @click="visibleMarkPoint = true">+标记知识点</a>
            <div class="kpointList">
              <div class="kpPointItem" v-for="(kpItem,index) in knowledgeList" :key="kpItem.id">
                <div class="numKey">{{ index + 1 }}</div>
                <ul class="kpContent">
                  <li>
                    <h4 @click="playRsc(kpItem)">{{ kpItem.partName }}</h4>
                  </li>
                  <li>
                    <span>{{ kpItem.startTime }} - {{ kpItem.endTime }}</span>
                    <div class="operation">
                      <a href="javascript:void(0)" class="del" @click="delKnowledge(kpItem.id)">删除</a>
                      <a
                          href="javascript:void(0)"
                          class="add"
                          @click="addKnowledgeParts(kpItem.id)"
                      >+知识单</a>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-card>
    <div class="bottom" v-if="videoRecommendList.length && otherRecommendList.length">
      <div class="videoRecommend">
        <div class="title">
          <h3>相关视频</h3>
        </div>
        <div class="carouselList">
          <slider :sliderList="videoRecommendList"></slider>
        </div>
      </div>
      <div class="otherRecommend">
        <div class="title">
          <h3>其他相关资源</h3>
        </div>
        <div class="otherRecommendList">
          <div class="recommendList">
            <router-link
                tag="a"
                target="_blank"
                :to="'/resource/detail?rscId=' + recommend.rscID"
                class="recommendItem"
                v-for="recommend in otherRecommendList"
                :key="recommend.rscID"
            >
              <i class="icon" :class="getClass(recommend.rscFileType)"></i>
              {{ recommend.title }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <mark-point
        :visible="visibleMarkPoint"
        @close="visibleMarkPoint = false"
        :rsc-id="rscID"
        @markSuccess="markSuccess"
    />
    <add-knowledge-part
        v-if="visibleAddKP"
        :visible="visibleAddKP"
        @close="visibleAddKP = false"
        :parts-id="addKPD"
        @addSuccess="addSuccess"
    />
  </div>
</template>
<script>
import {
  detailInfo,
  authorInfo,
  specialRecommend,
  videoRecommend,
  otherResourceRecommend,
  getPointList,
  deletePoint,
  buy,
  collect,
  cancelCollect,
  download
} from '@/api/resourceDetail';
import { isLoginApi } from '@/api/auth';
import { $Cookies, isMobile } from '@/utils';
import { AudioPlayer, SingleVideo, PDFPlayer } from '@/components/Player';
import markPoint from '@/components/Resource/markPoint';
import addKnowledgePart from '@/components/Resource/addKnowledgePart';
import slider from '@/components/slider';

export default {
  name: 'ResourceDetail',
  components: { PDFPlayer, SingleVideo, AudioPlayer, markPoint, addKnowledgePart, slider },
  data() {
    return {
      isLogged: false,
      timeout: null,
      rscPath: '',
      rscID: '',
      isMark: false,
      visibleMarkPoint: false,
      visibleAddKP: false,
      addKPD: 0,
      rscDetail: {
        title: '',
        rscDesc: '',
        tags: [],
        qrImageUrl: '',
        favNum: 0,
        downNum: 0,
        rscFileType: null,
        uploadDate: '',
        ifBuy: false,
        ifFree: false,
        favStatus: 0
      },
      author: {
        realName: '',
        iconPath: '',
        gradeName: '',
        schoolName: ''
      },
      recommendList: [],
      videoRecommendList: [],
      otherRecommendList: [],
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 0,
        loop: true,
        loopFillGroupWithBlank: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      knowledgeList: [],
      userNo: 0
    };
  },
  beforeCreate() {
    const rscID = this.$route.query.rscId || null;
    if (isMobile()) {
      window.location.href = `//www.g12e.org/m/resource/detail.html?rscId=${ rscID }`;
    }
  },
  async mounted() {
    this.rscID = this.$route.query.rscId || null;
    this.userNo = $Cookies.get('uid') ? Number($Cookies.get('uid')) : 0;
    await this.VerifyUser();
    await this.initResource();
    await this.getAuthorInfo();
    await this.getRecommendList();
    await this.getRecommendVideoList();
    await this.getOtherResourceRecommend();
  },
  methods: {
    async initResource() {
      const params = {
        userNo: this.userNo,
        rscID: this.rscID
      };
      await detailInfo(params).then(data => {
        if (data.success) {
          const {
            title,
            rscDesc,
            tags,
            qrImageUrl,
            favNum,
            downNum,
            rscFileType,
            uploadDate,
            ifBuy,
            ifFree,
            favStatus
          } = data.result;
          const tag = tags.length > 5 ? tags.slice(0, 5) : tags;
          if (tag.length) {
            for (let i = 0; i < tag.length; i++) {
              if (tag[i].length > 10) {
                const newTag = tag[i].substr(0, 9) + '...';
                tag[i] = newTag;
              }
            }
          }
          this.rscDetail = {
            title: title,
            rscDesc: rscDesc,
            qrImageUrl: qrImageUrl,
            favNum: favNum,
            tags: tag || [],
            downNum: downNum,
            rscFileType: rscFileType,
            uploadDate: uploadDate,
            ifBuy: ifBuy || false,
            ifFree: ifFree || false,
            favStatus: favStatus
          };
          document.title = `${ title }_中小学教育联盟网`;
        } else {
          this.$message.error(data.errorMsg);
        }
      });

    },
    async getAuthorInfo() {
      const params = {
        rscID: this.rscID
      };
      await authorInfo(params).then(data => {
        if (data.success) {
          const { realName, iconPath = null, gradeName, schoolName } = data.result;
          this.author = {
            realName: realName,
            iconPath: iconPath ? iconPath : '/styles/default_avatar.png',
            gradeName: gradeName,
            schoolName: schoolName
          };
        } else {
          this.$message.error(data.errorMsg);
        }
      });
    },
    async getRecommendList() {
      await specialRecommend(this.rscID).then(data => {
        if (data.success) {
          const specialRecommend = data.result;
          this.recommendList = specialRecommend.length > 2 ? specialRecommend.slice(0, 2) : specialRecommend;
        } else {
          this.$message({
            type: 'error',
            message: data.errorMsg
          });
        }
      });
    },
    async getRecommendVideoList() {
      const params = {
        rscID: this.rscID,
        rscFileType: 2
      };
      await videoRecommend(params).then(data => {
        if (data.success) {
          this.videoRecommendList = data.result;
        } else {
          this.$message.error(data.errorMsg);
        }
      });
    },
    async getOtherResourceRecommend() {
      await otherResourceRecommend({ userNo: this.userNo }).then(data => {
        if (data.success) {
          const recommendList = data.result.list || [];
          this.otherRecommendList = recommendList.length > 3 ? recommendList.slice(0, 3) : recommendList;
        } else {
          this.$message({
            type: 'error',
            message: data.errorMsg
          });
        }
      });
    },
    async VerifyUser() {
      await isLoginApi().then(data => {
        if (data.success) {
          const { isLogin } = data.result;
          if (isLogin) {
            this.isLogged = true;
          } else {
            this.isLogged = false;
          }
        }
      });
    },
    getClass(val) {
      let className = '';
      if (val === 1) {
        className = 'docRsc';
      } else if (val === 2) {
        className = 'videoRsc';
      } else if (val === 4) {
        className = 'audioRsc';
      }
      return className;
    },
    switchMark() {
      this.isMark = !this.isMark;
      if (this.isMark) this.getPointListFn();
    },
    getPointListFn() {
      const params = {
        rscID: this.rscID,
        userNo: this.userNo
      };
      getPointList(params).then(data => {
        if (data.success) {
          this.knowledgeList = data.result.partsList;
        } else {
          this.$message.error(data.errorMsg);
        }
      });
    },
    markSuccess() {
      this.visibleMarkPoint = false;
      this.getPointListFn();
    },
    delKnowledge(id) {
      this.$confirm('此操作将删除该知识点, 是否继续?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const params = {
          userNo: this.userNo,
          partID: id
        };
        deletePoint(params).then(data => {
          if (data.success) {
            this.$message({
              type: 'success',
              message: '知识点删除成功!',
              duration: 1500,
              onClose: () => {
                this.getPointListFn();
              }
            });
          } else {
            this.$message.error(data.errorMsg);
          }
        });
      }).catch(() => {
        return false;
      });
    },
    addKnowledgeParts(id) {
      this.visibleAddKP = true;
      this.addKPD = id;
    },
    addSuccess() {
      this.visibleAddKP = false;
    },
    buy() {
      const params = {
        rscID: this.rscID,
        userNo: this.userNo
      };
      buy(params).then(data => {
        if (data.success) {
          this.$message.success('获取成功！');
          clearTimeout(this.timeout);
          this.timeout = setTimeout(function () {
            location.reload();
          }, 1000);
        } else {
          this.$message.error(data.errorMsg);
        }
      });
    },
    collect() {
      const params = {
        rscID: this.rscID,
        userNo: this.userNo
      };
      collect(params).then(data => {
        if (data.success) {
          this.$message.success('收藏成功！');
          this.initResource();
        } else {
          this.$message.error(data.errorMsg);
        }
      });
    },
    cancelClick() {
      const params = {
        rscID: this.rscID,
        userNo: this.userNo
      };
      cancelCollect(params).then(data => {
        if (data.success) {
          this.$message.success('取消收藏！');
          this.initResource();
        } else {
          this.$message.error(data.errorMsg);
        }
      });
    },
    download() {
      const params = {
        rscID: this.rscID,
        userNo: this.userNo
      };
      download(params).then(data => {
        if (data.success) {
          this.rscPath = data.result.rscPath;
          window.open(this.rscPath);
        }
      });
    },
    playRsc(val) {
      const { startTime, endTime } = val;
      this.$refs.childVideo.clickChild(startTime, endTime);
    }
  }
};
</script>
